import { GraphqlRequestError } from '../apollo/graphql-request';

// API error codes the galleries page explains in the Provider's language; anything else gets
// the generic "could not save".
export const GALLERY_API_ERROR_CODES = [
  'GALLERY_PROVIDER_ONLY',
  'GALLERY_LIMIT_REACHED',
  'GALLERY_TITLE_TOO_LONG',
  'GALLERY_SHOOT_DATE_INVALID',
  'GALLERY_SELECTION_LIMIT_INVALID',
  'GALLERY_LAST_SECTION',
  'GALLERY_COVER_NOT_PHOTO',
  'GALLERY_PLAN_REQUIRED',
  'GALLERY_WATERMARK_LOGO_REQUIRED',
  'GALLERY_WATERMARK_TEXT_TOO_LONG',
] as const;

export type GalleryApiErrorCode = (typeof GALLERY_API_ERROR_CODES)[number];

export function galleryErrorMessage(
  error: unknown,
  messages: Record<GalleryApiErrorCode, string> & { actionFailed: string }
): string {
  const code = error instanceof GraphqlRequestError ? error.code : undefined;
  return code && (GALLERY_API_ERROR_CODES as readonly string[]).includes(code)
    ? messages[code as GalleryApiErrorCode]
    : messages.actionFailed;
}
